import { FunctionComponent } from "preact";

export const DottedLine: FunctionComponent = (props) => {
  return <hr className={"xendit-dotted-line"} />;
};
